import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import CompanionTabWrapper from './CompanionTabWrapper';
import QuizMeTab from './QuizMeTab';
import { jsx as _jsx } from "react/jsx-runtime";
const AICompanionTabs = () => {
  return /*#__PURE__*/_jsx(Tabs, {
    defaultSelected: "1",
    fill: true,
    children: /*#__PURE__*/_jsx(Tab, {
      tabId: "1",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.interactiveEducation.quiz.quizMe"
      }),
      children: /*#__PURE__*/_jsx(CompanionTabWrapper, {
        children: /*#__PURE__*/_jsx(QuizMeTab, {})
      })
    })
  });
};
export default AICompanionTabs;